import StoreExchangeCrud from "../components/store-exchanges/StoreExchangeCrud";

const StoreExchangeListPage = () => {
  return (
    <>
      <StoreExchangeCrud />
    </>
  );
};

export default StoreExchangeListPage;
